/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TipoPraticaIstitutoDTO { 
    id?: string;
    tipo_pratica_id?: string;
    nome?: string;
    codice_meccanografico?: string;
    attivo?: boolean;
    version?: number;
    created_at?: string;
    updated_at?: string;
}

